import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Dots from './Dots';
import Icon1 from './Icon1';
import Icon2 from './Icon2';
import Icon3 from './Icon3';
import styles from './Loading.module.css';

const Loading = () => {
  const navigate = useNavigate();

  // redirects to the results page after 4 seconds
  useEffect(() => {
    setTimeout(() => navigate('/results'), 4000);
  }, []);

  return (
    <div className={styles.wrapper}>
      <p>Thank you!</p>
      <h2 className={styles.heading}>Your personalized results are just seconds away.</h2>
      <Dots />
      <div className={styles.cardContainer}>
        <div className={styles.card}>
          <Icon3 />

          <p>
            <strong>Browse</strong> programs
          </p>
        </div>

        <div className={styles.card}>
          <Icon2 />

          <p>
            <strong>Find</strong> school matches
          </p>
        </div>
        <div className={styles.card}>
          <Icon1 />
          <p>
            <strong>Request information</strong> from schools
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
